import Reporter, { Env } from './reporter';

interface Props {
  delay?: number;
  env?: Env;
  printLog?: boolean;
}

interface CommonProps {
  deviceId?: string;
  deviceName?: string;
}

class Collector extends Reporter {
  private commonProps?: object | null;
  private delay?: number;
  private printLog?: boolean;
  private cache: any[];
  constructor(props: Props) {
    super({ env: props.env });
    const { delay = 5000, printLog = false } = props;
    this.commonProps = null;
    this.delay = delay;
    this.cache = [];
    this.printLog = printLog;

    this._setTimer();
  }

  private _cacheLog = (data: object) => {
    if (this.commonProps) {
      data = { ...data, ...this.commonProps };
    }
    this.cache.push(data);
  };

  private _sendLog = () => {
    // 每次最多上报20条
    const logs = this.cache.splice(0, 20);
    if (logs.length === 0) return;

    // TODO: 还没设置正确的report dataId 暂时不上报
    // this.report(logs);
  };

  private _setTimer = () => {
    const self = this;
    setTimeout(() => {
      self._sendLog();
      self._setTimer();
    }, this.delay);
  };

  public setCommonProps = (commonProps: CommonProps) => {
    this.commonProps = { ...this.commonProps, ...commonProps };
  };

  public info = (...args: any[]) => {
    if (this.printLog) {
      console.info(...args);
    }

    const logValue = JSON.stringify({ ...args });
    const logTime = new Date();
    this._cacheLog({ logType: 'info', logValue, logTime });
  };

  public error = (...args: any[]) => {
    if (this.printLog) {
      console.error(...args);
    }

    const logValue = JSON.stringify({ ...args });
    const logTime = new Date();
    this._cacheLog({ logType: 'error', logValue, logTime });
  };
}

export default Collector;
